"use client";

import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useRef as C, useState as $, useEffect as q } from "react";
import { classNames as x } from "../../utilities/index.js";
import _ from "../Label/index.js";
const E = _ref => {
    let {
      change: d,
      value: a,
      maxValue: y,
      className: N,
      labelText: r,
      helpText: t,
      tooltipContent: l,
      tooltipPosition: m = "bottom",
      required: g,
      assistiveText: c,
      error: n,
      errorText: b,
      ...k
    } = _ref;
    const s = C(null),
      [u, h] = $(!1),
      v = x({
        "sash-InputTooltip absolute bg-white p-2 border border-black z-2 text-caption shadow-md right-0 max-w-[40ch] w-fit": !0,
        "bottom-full": m === "top",
        "top-full": m === "bottom"
      }),
      w = x({
        "sash-Incrementer border border-black bg-white flex bg-white": !0,
        "border-black": !n,
        "border-red": n
      });
    q(() => {
      if (!(!l || !t)) return document.addEventListener("click", p), () => document.removeEventListener("click", p);
    }, [l, t]);
    const I = o => {
        o.preventDefault(), h(!u);
      },
      p = o => {
        var f;
        s != null && s.current && !((f = s.current) != null && f.contains(o.target)) && h(!1);
      };
    return /* @__PURE__ */i("div", {
      ref: s,
      className: `sash-IncrementerWrapper relative h-full ${N || ""}`,
      ...k,
      children: [(r || t) && /* @__PURE__ */i("div", {
        className: `relative flex items-center ${!c && (r || t) ? "mb-1" : ""}`,
        children: [/* @__PURE__ */e(_, {
          className: `flex-1 ${g ? "text-required" : ""}`,
          "aria-label": r,
          error: n,
          children: r
        }), t && /* @__PURE__ */e("button", {
          className: "ml-auto flex-none text-xs leading-tight text-blue hover:underline",
          onClick: I,
          children: t
        }), u && l && /* @__PURE__ */e("div", {
          className: v,
          children: l
        })]
      }), c && /* @__PURE__ */e("p", {
        className: `mb-1 mt-px text-xs leading-tight ${n ? "text-red" : "text-gray-60"}`,
        children: c
      }), /* @__PURE__ */i("div", {
        className: w,
        children: [/* @__PURE__ */e("div", {
          className: "sash-IncrementerDecrease flex-initial leading-none",
          children: /* @__PURE__ */e("button", {
            type: "button",
            "aria-label": "decrease quantity",
            onClick: () => d(a - 1),
            disabled: a === 1,
            className: "cursor-pointer px-2.5 py-4 hover:text-gray-70 disabled:pointer-events-none disabled:opacity-50 sm:px-4",
            children: /* @__PURE__ */e("span", {
              className: "material-symbols-sharp block !leading-none",
              children: "remove_circle_outline"
            })
          })
        }), /* @__PURE__ */e("div", {
          className: "sash-IncrementerCount flex-1 text-center",
          children: /* @__PURE__ */e("button", {
            type: "button",
            className: "opacity-1 h-full w-10 border-0 py-1 font-normal text-black",
            "aria-label": "quantity",
            "aria-disabled": !0,
            disabled: !0,
            children: a
          })
        }), /* @__PURE__ */e("div", {
          className: "sash-IncrementerIncrease flex-initial leading-none",
          children: /* @__PURE__ */e("button", {
            type: "button",
            "aria-label": "increase quantity",
            onClick: () => d(a + 1),
            className: "cursor-pointer px-2.5 py-4 hover:text-gray-70 disabled:pointer-events-none disabled:opacity-50 sm:px-4",
            disabled: a >= y,
            children: /* @__PURE__ */e("span", {
              className: "material-symbols-sharp block !leading-none",
              children: "add_circle_outline"
            })
          })
        })]
      }), n && b && /* @__PURE__ */i("p", {
        className: "flex items-center text-xs text-red",
        children: [/* @__PURE__ */e("span", {
          className: "material-symbols-sharp mr-1 text-base",
          children: "warning"
        }), b]
      })]
    });
  },
  z = E;
export { z as default };